import lazyLoadView from "@router/lazyload-view";
import routeError from "@router/route-error";
import store from '@src/store'
import _find from 'lodash/find'
import { eventIsStart } from "@utils/zerone-event";

export default [
  // 會員中心
  {
    path: '/member',
    name: 'member',
    component: () => lazyLoadView(import('@views/Member/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      isLoginPage: true,
      title: '會員中心'
    },
  },
  // 會員中心 會員基本資料
  {
    path: '/member/info',
    name: 'member-info',
    component: () => lazyLoadView(import('@views/MemberSetting/Info')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          routeTo.params.defaultValue = await store.dispatch('auth/fetchUser');
          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: 'login' }));
        }
      },
      isLoginPage: true,
      title: '會員中心-會員基本資料'
    },
    props: (route) => ({
      defaultValue: route.params.defaultValue,
    }),
  },
  // 會員中心 會員設定
  {
    path: '/member/setting',
    name: 'member-setting',
    component: () => lazyLoadView(import('@views/MemberSetting/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          routeTo.params.defaultValue = await store.dispatch('auth/fetchUser');
          const copyData = JSON.parse(JSON.stringify(routeTo.params.defaultValue))
          routeTo.params.copyData = copyData
          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: 'login' }));
        }
      },
      isLoginPage: true,
      title: '會員中心-會員設定'
    },
    props: (route) => ({
      // defaultValue: route.params.defaultValue,
      defaultValue: route.params.copyData,
    }),
  },
  // 會員中心 報名清單 零壹活動
  {
    path: '/member/activity',
    name: 'member-activity-list',
    component: () => lazyLoadView(import('@views/MemberEvent/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          await store.dispatch('option/fetchOptionList', {
            types: ['brand'],
            useCached: true
          });
          routeTo.params.eventCategoryAlias = 'activity';
          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      isLoginPage: true,
      title: '會員中心-活動課程列表'
    },
  },
  // 會員中心 報名清單 零壹活動 內容頁
  {
    path: '/member/activity/:eventAlias/:eventSeriesNum',
    name: 'member-activity-item',
    component: () => lazyLoadView(import('@views/MemberEvent/Item')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [
            currentOrderItem
          ] = await Promise.all([
            store.dispatch('order/fetchOrderItem', {
              eventAlias: routeTo.params.eventAlias,
              seriesNum: routeTo.params.eventSeriesNum,
            }),
          ]);

          // routeTo.params.breadcrumbTitle = currentOrderItem.items.title;
          routeTo.params.orderItem = currentOrderItem.items;

          next()
        } catch (error) {
          alert('您沒有報名本場活動，無法觀看');

          if (routeFrom.name === 'brand-event-item') {
            next({ name: 'brand-event-item' })
          } else {
            routeError(error, routeTo, next({ name: '404' }));
          }
        }
      },
      isLoginPage: true,
      title: '會員中心-活動課程訂單'
    },
    props: (route) => ({
      // pageType: route.params.pageType
      orderItem: route.params.orderItem || {},
    })
  },
  // 會員中心 報名清單 零壹課程 列表頁
  {
    path: '/member/event',
    name: 'member-event-list',
    component: () => lazyLoadView(import('@views/MemberEvent/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          await store.dispatch('option/fetchOptionList', {
            types: ['brand'],
            useCached: true
          });
          routeTo.params.eventCategoryAlias = 'course';
          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      isLoginPage: true,
      title: '會員中心-活動課程列表'
    },
  },
  // 會員中心 報名清單 零壹課程 內容頁
  {
    path: '/member/event/:eventAlias/:eventSeriesNum',
    name: 'member-event-item',
    component: () => lazyLoadView(import('@views/MemberEvent/Item')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [
            currentOrderItem
          ] = await Promise.all([
            store.dispatch('order/fetchOrderItem', {
              eventAlias: routeTo.params.eventAlias,
              seriesNum: routeTo.params.eventSeriesNum,
            }),
          ]);

          // routeTo.params.breadcrumbTitle = currentOrderItem.items.title;
          routeTo.params.orderItem = currentOrderItem.items;

          next()
        } catch (error) {
          alert('您沒有報名本場課程，無法觀看');

          if (routeFrom.name === 'brand-event-item') {
            next({ name: 'brand-event-item' })
          } else {
            routeError(error, routeTo, next({ name: '404' }));
          }
        }
      },
      isLoginPage: true,
      title: '會員中心-活動課程訂單'
    },
    props: (route) => ({
      // pageType: route.params.pageType,
      orderItem: route.params.orderItem || {},
    })
  },
  // 會員中心 報名清單 零壹課程 直播課程頁
  {
    path: '/member/event/:eventAlias/:eventSeriesNum/live/:sessionUuid',
    name: 'member-event-item-live',
    component: () => lazyLoadView(import('@views/MemberEvent/Live')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [
            currentOrderItem
          ] = await Promise.all([
            store.dispatch('order/fetchOrderItem', {
              eventAlias: routeTo.params.eventAlias,
              seriesNum: routeTo.params.eventSeriesNum,
            }),
          ]);



          const currentSessionItem = () => {
            const sessionItem = _find(currentOrderItem.items.sessions, session => {
              return _find(session.sessions, sessionSession => {
                return sessionSession.info.uuid === routeTo.params.sessionUuid
              })
            });

            return sessionItem
              ? {
                date: sessionItem.date,
                ..._find(sessionItem.sessions, sessionSession => {
                  return sessionSession.info.uuid === routeTo.params.sessionUuid
                })
              }
              : null
          };

          const isRegConfirmed = () => {
            if (currentOrderItem.registrationType === "partial") {
              return currentSessionItem()?.regStatus === 'CONFIRMED';
            } else {
              return currentOrderItem.regStatus === 'CONFIRMED'
            }
          }
          isRegConfirmed()
          const isStart = eventIsStart(currentSessionItem()?.info?.linkOpeningTime);

          const goToMemberEventItem = () => {
            next({
              name: 'member-event-item',
              params: {
                eventAlias: routeTo.params.eventAlias,
                eventSeriesNum: routeTo.params.eventSeriesNum,
              }
            })
          };

          if (currentOrderItem.items.type !== 'online') {
            alert('此活動未開放直播 \n系統將重新導向至報名詳情頁面');

            return goToMemberEventItem()
          }

          if (!currentSessionItem() || !currentSessionItem().info) {
            if (routeFrom.name === 'brand-event-item') {
              alert('您沒有報名此場直播或者直播已關閉 \n系統將重新導向至報名詳情頁面');
            } else {
              alert('直播已關閉 \n系統將重新導向至報名詳情頁面');
            }
            return goToMemberEventItem()
          }

          if (!isRegConfirmed) {
            alert('您尚未通過審核 \n系統將重新導向至報名詳情頁面');

            return goToMemberEventItem()
          }

          if (!isStart) {
            alert('直播尚未開放 \n系統將重新導向至報名詳情頁面');

            return goToMemberEventItem()
          }



          // routeTo.params.breadcrumbTitle = currentOrderItem.items.title;
          routeTo.params.orderItem = currentOrderItem.items;
          routeTo.params.sessionItem = currentSessionItem();

          next()
        } catch (error) {
          alert('您沒有報名本場此直播，無法觀看');

          if (routeFrom.name === 'brand-event-item') {
            next({ name: 'brand-event-item' })
          } else {
            routeError(error, routeTo, next({ name: '404' }));
          }
        }
      },
      isLoginPage: true,
      title: '會員中心-直播課程'
    },
    props: (route) => ({
      orderItem: route.params.orderItem || {},
      sessionItem: route.params.sessionItem || {}
    })
  },
  {
    path: '/member/coupon',
    name: 'member-coupon-list',
    component: () => lazyLoadView(import('@views/MemberCoupon/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      isLoginPage: true,
      title: '優惠卷',
    },
  }
]
